import React from 'react';
import CV from '../../assets/CV_Felipe_Alberto-2.pdf';
import { FiDownload, FiSend } from 'react-icons/fi';

const CTA = () => {
  return (
    <div className='cta'>
      <a href={CV} download className='btn'>
        <FiDownload /> Resume
      </a>
      <a href='#contact' className='btn btn-primary'>
        <FiSend /> Let&apos;s talk
      </a>
    </div>
  );
};

export default CTA;
